import { makeStyles, createStyles } from '@material-ui/core/styles';

import { theme, variables } from '@styles';

/**
 * TemplateItem component styles
 * @returns {Function}
 */

export const useStyles = makeStyles(() =>
  createStyles({
    templateItem: {
      height: '20.3rem',
      backgroundColor: variables.colorV2.contentModuleCard.default.background.default,
      padding: theme.spacing(2),
      marginBottom: theme.spacing(1),
      border: ({ selected }: { selected: boolean }) =>
        selected
          ? `.2rem solid ${variables.colorV2.contentModuleCard.default.border.active}`
          : `.1rem solid ${variables.colorV2.contentModuleCard.default.border.listing}`,
      borderRadius: '.8rem',
      cursor: 'pointer',

      '&:hover': {
        border: `2px solid ${variables.colorV2.contentModuleCard.default.border.hover}}`,
      },
    },

    content: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },

    leftContent: {
      width: '90%',
    },

    image: {
      objectFit: 'cover',
      height: '12.6rem',
      width: '100%',
      marginBottom: theme.spacing(0.5),
    },

    iconListItem: {
      stroke: variables.colorV2.contentModuleCard.default.icon.stroke.default,
      minWidth: 'unset',
    },

    name: {
      color: variables.colorV2.contentModuleCard.default.text.default,
    },

    experience: {
      color: variables.colorV2.contentModuleCard.default.text.default,
    },
  }),
);
